import api, { ApiResponse } from './api';

export interface SystemPermission {
  code: string;
  name: string;
  category: string;
}

const permissionService = {
  // Kullanıcının yetkilerini getir
  getUserPermissions: async (userId: number): Promise<ApiResponse<string[]>> => {
    return api.get(`/permissions/user/${userId}`);
  },

  // Kullanıcının yetkilerini kaydet
  saveUserPermissions: async (userId: number, permissions: string[]): Promise<ApiResponse<{ userId: number; permissionCount: number }>> => {
    return api.post(`/permissions/user/${userId}`, { permissions });
  },

  // Tüm sistem izinlerini getir
  getAllPermissions: async (): Promise<ApiResponse<SystemPermission[]>> => {
    return api.get('/permissions/all');
  },
};

export default permissionService;
